module.exports = __webpack_public_path__ + "static/media/map.6868ada6.png";